// 마진/플로우 공용 소품 — ops-britzmedi margin/ui.tsx 이식 (무수정).
export const TH =
  "border border-line bg-surface-2 px-2 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-graphite-mut whitespace-nowrap";
export const TD =
  "border border-line px-2 py-1 text-right text-sm font-mono tabular-nums text-graphite whitespace-nowrap";
export const neg = (n: number) => (n < 0 ? " text-risk font-semibold" : "");
export const btn =
  "rounded border border-line bg-surface px-2 py-1 text-xs text-graphite-mut hover:bg-surface-2";

export function NumInput({
  value,
  onChange,
  step = 1,
  className = "",
}: {
  value: number;
  onChange: (v: number) => void;
  step?: number;
  className?: string;
}): JSX.Element {
  return (
    <input
      type="number"
      value={Number.isFinite(value) ? value : ""}
      step={step}
      onChange={(e) => onChange(e.target.value === "" ? NaN : Number(e.target.value))}
      className={
        (className.includes("w-") ? "" : "w-full ") +
        "rounded border border-line bg-surface px-2 py-1 text-right text-sm font-mono tabular-nums text-graphite focus:border-brass focus:outline-none " +
        className
      }
    />
  );
}

export function TextInput({
  value,
  onChange,
  className = "",
  placeholder,
}: {
  value: string;
  onChange: (v: string) => void;
  className?: string;
  placeholder?: string;
}): JSX.Element {
  return (
    <input
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className={
        "w-full rounded border border-line bg-surface px-2 py-1 text-sm text-graphite focus:border-brass focus:outline-none " +
        className
      }
    />
  );
}
